module.exports = __webpack_public_path__ + "assets/img/11_997_big.377ec6c9.jpg";